import { ItaAdComponent } from './../../_shared/components/ita-ad/ita-ad.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TranslateModule } from '@ngx-translate/core';
import { ShareMatchComponentModule } from '../../_shared/components/share-match/share-match.module';
import { EmptyPageModule } from '../../empty-page/empty-page.module';
import { MatchFormatFormModule } from '../../matches/match-format-form/match-format-form.module';
import { ScoreboardModule } from '../../scoreboard/scoreboard.module';
import { AddCollectionDefinitionComponent } from '../add-collection-definition/add-collection-definition.component';
import { TieDetailsPopoverComponent } from '../tie-details-popover/tie-details-popover.component';
import { TieDetailsPageRoutingModule } from './tie-details-routing.module';
import { TieDetailsComponent } from './tie-details.component';
import { TieMatchListModule } from './tie-match-list/tie-match-list.module';
import { LoginModalModule } from '../../_shared/components/login-modal/login-modal.module';
import { TieScorecardModule } from './tie-scorecard/tie-scorecard.module';
import { CollectionHeaderModule } from './collection-header/collection-header.module';
import { AddTemplateModule } from '../../_shared/components/add-template/add-template.module';
import { DatetimeModule } from '../../_shared/components/datetime/datetime.module';
import { SubmitScoreReportComponent } from './submit-score-report/submit-score-report.component';
import { PickleballMatchFormatFormComponent } from '../../matches/pickleball-match-format-form/pickleball-match-format-form.component';
import { RoundSettingsComponent } from '../../leagues/league-details/round-settings/round-settings.component';
import { FollowTieComponent } from './follow-tie/follow-tie.component';
import { ManageScoreSubscriptionComponent } from '../../scoreboard/manage-score-subscription/manage-score-subscription.component';
import { BadmintonMatchFormatFormComponent } from '../../matches/badminton-match-format-form/badminton-match-format-form.component';
import { TableTennisMatchFormatFormComponent } from '../../matches/table-tennis-match-format-form/table-tennis-match-format-form.component';
import { SquashMatchFormatFormComponent } from '../../matches/squash-match-format-form/squash-match-format-form.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        TranslateModule.forChild(),
        ScoreboardModule,
        EmptyPageModule,
        ShareMatchComponentModule,
        TieDetailsPageRoutingModule,
        MatchFormatFormModule,
        PickleballMatchFormatFormComponent,
        LoginModalModule,
        TieMatchListModule,
        TieScorecardModule,
        CollectionHeaderModule,
        AddTemplateModule,
        DatetimeModule,
        ItaAdComponent,
        FollowTieComponent,
        ManageScoreSubscriptionComponent,
        BadmintonMatchFormatFormComponent,
        TableTennisMatchFormatFormComponent,
        SquashMatchFormatFormComponent
    ],
    declarations: [
        TieDetailsComponent,
        AddCollectionDefinitionComponent,
        TieDetailsPopoverComponent,
        SubmitScoreReportComponent,
        RoundSettingsComponent,
    ]
})
export class TieDetailsPageModule { }
